<template>
  <div class="c-to-prev-page">
    <router-link :to="{ name: routeName }">
    <div class="arrow-label-wrap">
      <div class="yellow-circle">
        <img src="@/assets/icon/icon_arrow_left.svg" />
      </div>
      <p class="label">返回{{ route.meta.banner.subTitle }}</p>
      </div>
    </router-link>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'ToPrevPage',
  props: {
    routeName: {
      type: String,
      defualt: '',
      required: true,
    },
  },
  setup() {
    const route = useRoute();

    return {
      route,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-to-prev-page {
  margin-top: 50px;

}

.arrow-label-wrap {
  @include flex();

}

.yellow-circle {
  width: 40px;
  height: 40px;
  @include flex(center);
  background-color: $c-main-yellow;
  border-radius: 20px;
}

.label {
  margin-left: 20px;
  @include font-normal();
}
</style>
